"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const formik_1 = require("formik");
const Modal_1 = __importDefault(require("@/components/Modal"));
const Input_1 = __importDefault(require("@/components/Input"));
const Button_1 = __importDefault(require("@/components/Button"));
const AutocompleteField_1 = __importDefault(require("@/components/AutocompleteField"));
const MultiSelectAutocomplete_1 = __importDefault(require("@/components/MultiSelectAutocomplete"));
const constants_1 = require("../../UsersTable/constants");
const style_1 = require("../style");
function UserFormView({ isOpen, onClose, values, onChange, onSubmit, errors, isLoading, onBlur, formTitle, touched, confirmActionText, }) {
    const formik = (0, formik_1.useFormikContext)();
    const buildRoleValues = (roles) => {
        return constants_1.ROLE_OPTIONS.reduce((acc, current) => {
            if (roles.includes(current.value)) {
                acc = [
                    ...acc,
                    {
                        label: current.label,
                        value: current.value,
                    },
                ];
            }
            return acc;
        }, []);
    };
    const roleValues = buildRoleValues(values.roles);
    const isDepartmentOptionEqualToValue = (option, value) => {
        if (values?.department) {
            return option.value === values.department;
        }
        return option.value === value.value;
    };
    const getDepartmentOptionLabel = (option) => {
        if (typeof option === "string") {
            return constants_1.DEPARTMENT_OPTIONS.find((opt) => opt.value === option)
                ?.label;
        }
        return option.label;
    };
    const onChangedDepartmentValue = (event, option) => {
        formik.setFieldValue("department", option?.value);
    };
    const onChangeRoleValue = (event, value) => {
        const roles = value.map((value) => value.value);
        formik.setFieldValue("roles", [...roles]);
    };
    const getRolesLabels = (option) => {
        if (typeof option === "string") {
            return constants_1.ROLE_OPTIONS.find((opt) => opt.value === option)
                ?.label;
        }
        return option?.label;
    };
    return (react_1.default.createElement(Modal_1.default, { title: formTitle, isOpen: isOpen, onClose: onClose },
        react_1.default.createElement(formik_1.Form, null,
            react_1.default.createElement(style_1.FormSection, null,
                react_1.default.createElement(style_1.StyledFormControl, null,
                    react_1.default.createElement(Input_1.default, { name: "username", id: "username", onBlur: onBlur, error: Boolean(errors["username"] && touched["username"]), helperText: touched["username"] ? errors["username"] : "", onChange: onChange, label: "Name", disabled: isLoading, value: values.username, required: true })),
                react_1.default.createElement(style_1.StyledFormControl, null,
                    react_1.default.createElement(Input_1.default, { onChange: onChange, name: "email", onBlur: onBlur, error: Boolean(errors["email"] && touched["email"]), helperText: touched["email"] ? errors["email"] : "", label: "E-mail", disabled: isLoading, id: "email", value: values.email, required: true })),
                react_1.default.createElement(style_1.StyledFormControl, null,
                    react_1.default.createElement(AutocompleteField_1.default, { onChange: onChangedDepartmentValue, name: "department", options: constants_1.DEPARTMENT_OPTIONS, label: "Department", isOptionEqualToValue: isDepartmentOptionEqualToValue, getOptionLabel: getDepartmentOptionLabel, onBlur: onBlur, error: Boolean(errors["department"] && touched["department"]), helperText: touched["department"] ? errors["department"] : "", id: "formula", disabled: isLoading, value: values?.department || "" })),
                react_1.default.createElement(style_1.StyledFormControl, null,
                    react_1.default.createElement(MultiSelectAutocomplete_1.default, { onChange: onChangeRoleValue, getOptionLabel: getRolesLabels, value: roleValues, options: constants_1.ROLE_OPTIONS, name: "roles", error: Boolean(errors["roles"] && touched["roles"]), helperText: Boolean(errors["roles"]) ? errors["roles"] : "", label: "Roles", required: true, id: "roles", disabled: isLoading })),
                react_1.default.createElement(style_1.FormActions, null,
                    react_1.default.createElement(Button_1.default, { label: "Cancel", disabled: isLoading, onClick: onClose, size: "medium", variant: "outlined", color: "secondary" }),
                    react_1.default.createElement(Button_1.default, { label: confirmActionText, onClick: onSubmit, isLoading: isLoading, disabled: isLoading || !formik.dirty, size: "medium", color: "primary", variant: "contained" }))))));
}
exports.default = UserFormView;
